import copy from 'fast-copy';
import { toast } from 'react-toastify';
import isEqual from 'react-fast-compare';
import React, { useEffect, useState } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { useTranslation } from 'react-i18next';
import { arrayMoveImmutable } from 'array-move';
import BeatLoader from 'react-spinners/BeatLoader';
import Swal from 'sweetalert2'

import { Container, Draggable } from 'react-smooth-dnd';

import {
  Button, TextField, InputAdornment, Select, MenuItem,
  InputLabel, FormControl
} from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';

import Prompt from '../../../Shared/Prompt/Prompt';
import PromptWrapper from '../../../Shared/Prompt/Wrapper';
import PromptActions from '../../../Shared/Prompt/Actions';

import { update } from '../../../../Functions/admin';
import { useAppContext } from '../../../../Context/App/Provider';
import { useEventContext } from '../../../../Context/Event/Provider';
import { setLocationGridValues, decodeHTMLEntities } from '../../../../Functions/utils';
import { getModuleConditions, getScenarioLines, getSequencesFromLines, getModuleConditionsTextOnly } from '../../../../Functions/utils';

import Module from './Modules/Module';
import UpdateModule from './Modules/Update';

import ModuleWithSequence from './Modules/ModuleWithSequence';

import { colors, roles, sharingValues, devicesTypeValues, toastTimerValue } from '../../../../Shared/utils';
import { multiSelectStrings } from '../../../../Functions/utils';
import { useReportingContext } from '../../../../Context/Reporting/Provider';
import { getScenario, updateScenario } from '../../../../Functions/scenarios';

import '../../../SweetAlert.css'



const getScenarioLocs = (pickers, scenario) => {
  if (!scenario || scenario.sharingOptions === sharingValues.everyone/*|| !scenario.private*/) return { groups: [], locations: [] };

  return {
    groups: scenario.groups,
    locations: []
  };
};

const getUnknownScenario = (history, t) => (
  <div className="loader">
    <div style={{ textAlign: 'center' }}>
      <h1>{t('scenarios.update.unknown.text')}</h1>

      <Button
        className="button"
        onClick={() => history.replace('/admin/scenarions')}
        style={{ marginTop: '50px', background: 'var(--button-bg)' }}
      >
        {t('scenarios.update.unknown.button')}
      </Button>
    </div>
  </div>
);




export default function UpdateScenarios({ scenarios, setScenarios, selectedScenario, setSelectedScenario }) {
  const { t } = useTranslation();
  const [{ user }, appDispatch] = useAppContext();
  const [{ refreshScenarios, scenariosStatus }, eventDispatch] = useEventContext();
  const [{ pickers }, dispatch] = useReportingContext();

  const [module, setModule] = useState(null);
  const [scenario, setScenario] = useState(selectedScenario);
  const [newScenario, setNewScenario] = useState(copy(scenario));

  const [loaded, setLoaded] = useState(selectedScenario ? true : false);
  const [belongs, setBelongs] = useState(getScenarioLocs(pickers, scenario));
  // const [open, setOpen] = useState(scenario ? scenario.modules.map(() => false) : null);


  const [lines, setLines] = useState(
    getScenarioLines(scenario) || []//handleAddLine
  );



  // Module functions
  // const handleAddModule = () => {
  //   const newModule = {
  //     seq: newScenario.modules.length + 1,
  //     newModule: true,
  //     moduleId: 1101,
  //     conditions: [/*{ seq: 1 }*/]
  //   };
  //   const modules = newScenario.modules.concat(newModule);
  //   setNewScenario({ ...newScenario, modules });
  //   // setOpen(open.concat(true));
  // };


  const handleRemoveModule = (module) => {

    const tmpScenario = copy(newScenario);

    tmpScenario.modules.splice(module.seq - 1, 1);
    tmpScenario.modules.forEach((module, index) => module.seq = index + 1);


    // SET MODULE IN LINES.lines
    const tmpLines = copy(lines);
    const index = tmpLines.findIndex(l => l.nbSeq === module.seq);
    tmpLines.splice(index, 1);         
    tmpLines.forEach((line, index) => line.nbSeq = index + 1);

    tmpScenario.modules.forEach((moduleTmp, index) => {
      tmpLines[tmpLines.findIndex(l => l.nbSeq === moduleTmp.seq)].module = moduleTmp;
    });


    if (tmpLines && tmpLines[0] && tmpLines[0].extra)
      tmpLines[0].extra = "";
    
    setLines(tmpLines);

    const newSequence = handleCheckLines(tmpLines);
    tmpScenario.sequence = newSequence;
    setNewScenario(tmpScenario);
  };


  const handleUpdateModule = (module) => {
    console.log("115 - module=", module);

    // SET MODULE IN LINES. 
    const tmpLines = copy(lines);
    tmpLines[tmpLines.findIndex(l => l.nbSeq === module.seq)].module = module;

    const newSequence = handleCheckLines(tmpLines);
    setLines(tmpLines);

    // SET MODULE IN NEW SCENARIO. 
    const modules = copy(newScenario).modules;
    modules[modules.findIndex(m => m.seq === module.seq)] = module;
    setNewScenario({ ...newScenario, modules, sequence: newSequence });

    setModule(null);
  };


  const handleDragModule = ({ removedIndex, addedIndex }) => {
    const modules = arrayMoveImmutable(newScenario.modules, removedIndex, addedIndex);
    modules.forEach((module, index) => module.seq = index + 1);
    setNewScenario({ ...newScenario, modules });

    // setOpen(arrayMoveImmutable(open, removedIndex, addedIndex)); // Handle open / collapsed modules
  };




  const handleAddLine = () => {

    const newModule = {
      seq: newScenario.modules.length + 1,
      newModule: true,
      moduleId: 1101,
      conditions: [/*{ seq: 1 }*/]
    };
    const modules = newScenario.modules.concat(newModule);


    // XXXXXXX Get SEQUENCE + MODULES => SetNewScenario !
    const tmpLine = {
      extra: (lines.length === 0 ? "" : "AND"),
      first: 0,
      last: 0,
      scModuleId: null,
      scenarioId: scenario.id,
      nbSeq: newModule.seq,
      module: newModule
    }
    const tmpLines = copy(lines);
    tmpLines.push(tmpLine);

    const newSequence = handleCheckLines(tmpLines);
    setLines(tmpLines);
    setNewScenario({ ...newScenario, modules, sequence: newSequence });
  };


  const handleChangeLine = (line, type, value) => {


    // const modules = copy(newScenario).modules;
    // modules[modules.findIndex(m => m.seq === line.module.seq)] = line.module;

    // setNewScenario({ ...newScenario, modules });
    // setModule(null);
    // console.log("159 - lines=", lines);

    // console.log("159 - line=", line);
    // console.log("160 - type=", type);
    // console.log("161 - value=", value);

    const newLines = copy(lines);
    newLines[line.nbSeq - 1][type] = value;

    const newSequence = handleCheckLines(newLines);
    setLines(newLines);
    setNewScenario({ ...newScenario, sequence: newSequence });
  };


  const handleRemoveLine = (line) => {

    handleRemoveModule(line.module);
    // lines.splice(line.seq, 1);
    // if (lines && lines[0] && lines[0].extra)
    //   lines[0].extra = "";

    // handleCheckLines(lines);
    // setLines(lines);
  };


  const handleCheckLines = (lines) => {

    const postfix = getSequencesFromLines(lines);
    // console.log("229 - postfix=", lines, postfix);
    const sequence = [];

    let seq = 1;
    for (const element of postfix) {

      const item = {
        operator: element.operator,
        scenarioModuleId: element.operator ? null : (Number(element.scModuleId) || null),
        scenarioId: Number(element.scenarioId),
        seq: Number(seq),
      }

      sequence.push(item);
      seq++;
    }
    console.log("250 - sequence=", sequence);
    return sequence;
  }









  // Scenario functions
  const handleChangeGroup = (e) => {
    // console.log("125 - e=", e);
    setNewScenario({ ...newScenario, groups: [Number(e.target.value)], locations: [] });
    // setBelongs({ groups: [Number(e.target.value)], locations: [] });
  };


  const handleResetScenario = () => {
    setNewScenario(copy(scenario));
    // setOpen(scenario.modules.map(() => false));
    // setBelongs(getScenarioLocs(pickers, scenario));
  };

  const handleUpdateScenario = () => {
    if (!newScenario.label)
      return toast(decodeHTMLEntities(t('scenarios.errors.no_name')), { type: 'error' });

    if (newScenario.modules.length === 0)
      return toast(decodeHTMLEntities(t('scenarios.errors.no_module')), { type: 'error' });

    if (newScenario.sharingOptions === sharingValues.allGroupUsers && newScenario.groups && newScenario.groups.length === 0)
      return toast(decodeHTMLEntities(t('scenarios.errors.no_location')), { type: 'error' });

    let invalidModule = false;
    newScenario.modules.map((module, key) => {
      if (module.conditions.length === 0) {
        invalidModule = true;
      }
    })
    if (invalidModule)
      return toast(decodeHTMLEntities(t('scenarios.errors.no_condition')), { type: 'error' });


    // console.log("305 - newScenario=", newScenario);

    setLoaded(false);
    updateScenario(newScenario).then(res => {
      if (!res.success) {
        setLoaded(true);
        return toast(decodeHTMLEntities(t('scenarios.errors.' + res, { label: scenario.label })), { type: 'error' });
      }

      setNewScenario(res.scenario);
      dispatch({ settingsScenarios: null });
      setScenarios([]);
      setSelectedScenario(null);

      toast(decodeHTMLEntities(t('scenarios.update.success', { label: scenario.label })), { type: 'success' });

      eventDispatch({ scenariosStatus: "full-force", refreshScenarios: true });
    });
  };

  // const handleGoBack = () => {
  //   if (isEqual(scenario, newScenario)) {
  //     // If state is null, the user has no history state, don't go back
  //     return state ? history.goBack() : history.push('/admin/scenarios');
  //   }


  //   Swal.fire({
  //     allowOutsideClick: false,
  //     title: t('global.dialog_title'),
  //     html: t('scenarios.update.unsaved'),
  //     showCancelButton: true,
  //     confirmButtonText: t("global.yes"),
  //     cancelButtonText: t("global.no"),
  //     customClass: {
  //       confirmButton: 'confirm-button-class',
  //       title: 'title-class',
  //       icon: 'icon-class'
  //     }
  //   }).then((value) => {
  //     // console.log("239 - value=", value);

  //     if (value && value.isConfirmed) {
  //       history.goBack();
  //     }
  //     else if (value && value.isDismissed) {
  //       history.push('/admin/scenarios');
  //     }
  //   });
  // };


  // useEffect(() => {
  //   // console.log("223 - useEffect... id, loaded, pickers, scenario, user, setScenario, t");
  //   if (!scenario && !loaded) {
  //     // getScenario(id).then(({ scenario, success }) => {

  //     //   // console.log("184 - scenario=", scenario);
  //     //   if (success) {
  //     //     // Don't show scenario if user isn't st admin and doesn't have access to the scenario's group
  //     //     const hasSites = pickers.locations.all.some(loc => scenario.locations.includes(loc.value));

  //     //     if (user.roleId <= roles.stAdmin || hasSites) {
  //     //       setScenario(scenario);
  //     //       setNewScenario(scenario);
  //     //       setOpen(scenario.modules.map(() => false));

  //     //       if (!scenario.private) setBelongs(getScenarioLocs(pickers, scenario));
  //     //       document.title = t('scenarios.update.title', { label: scenario.label });
  //     //     }
  //     //   }

  //     //   setLoaded(true);
  //     // });
  //   }
  // }, [id, loaded, pickers, scenario, user, setScenario, t]);

  useEffect(() => {
    // console.log("248 - useEffect... newScenario, scenario, t]");
    if (scenario) document.title = t('scenarios.update.title', { label: scenario.label });

    // Warning popup on refresh if scenario was edited
    const warning = (e) => {
      e.preventDefault();
      if (!isEqual(newScenario, scenario)) e.returnValue = '';
    }
    window.addEventListener('beforeunload', warning);

    return () => window.removeEventListener('beforeunload', warning);
  }, [newScenario, scenario, t]);



  let errorInLines = false;
  // console.log("397 - lines=", lines);
  // console.log("397 - length=", lines.length);
  // console.log("397 - getSequencesFromLines(lines)=", getSequencesFromLines(lines));
  // console.log("397 - etSequencesFromLines(lines).length=", getSequencesFromLines(lines).length);

  if (lines.length > 0 && (getSequencesFromLines(lines).length === 0 /*|| getModuleConditions(t, newModule.conditions, '').text === ""*/))
    errorInLines = true;


  // console.log("254 - newScenario=", newScenario);
  // console.log("255 - lines=", lines);
  // console.log("257 - TEST=", getSequencesFromLines(lines))

  return (
    <Prompt animated>
      <form
        className="prompt__container animated"
        style={{
          maxWidth: '920px'
        }}
        onSubmit={e => {
          // console.log("209 - e=", e);
          // handleUpdateLocation(e, newLocation);
        }}
      >
        <PromptWrapper>
          <div className="prompt__title">
            <h1 title={scenario.label}>
              {decodeHTMLEntities(t('admin.locations.update.title', { name: scenario.label }))}
            </h1>
            {user.roleId <= roles.stAdmin && <div>
              <span>
                <h3 style={{ margin: '0 auto', padding: '20px 0' }}>
                  ({scenario.creatorEmail})
                </h3>
              </span>
            </div>}
          </div>


          <div className="prompt__content">
            <div className="flexRow" style={{ alignItems: 'flex-end' }}>

              <TextField
                InputProps={{
                  startAdornment: <InputAdornment position="start">
                    <span className="material-icons-outlined">description</span>
                  </InputAdornment>
                }}
                required
                variant="outlined"
                style={{ width: '100%' }}
                label={t('scenarios.name')}
                value={newScenario.label ?? ''}
                //style={{ /*flexGrow: 1,*/ margin: '5px 50px 5px 5px' }}
                onChange={e => setNewScenario({ ...newScenario, label: e.target.value })}
                disabled={(newScenario.owner !== user.id) && (user.roleId !== roles.dashboardSuperAdmin)}
              />
            </div>

            <div >
              <div style={{ padding: 0 }}>
                <p className="sidebar__label">{t('scenarios.devicesType')}</p>
                <select
                  disabled
                  value={newScenario.devicesType}
                  className="singleSelect"
                  title={t('scenarios.devicesType')}
                  onChange={e => {
                    const devicesType = Number(e.target.value);
                    setNewScenario({ ...newScenario, devicesType: devicesType })
                  }}
                >
                  <option value={devicesTypeValues.PCs}>{t('scenarios.devicesType_PCs')}</option>
                  <option value={devicesTypeValues.mobiles}>{t('scenarios.devicesType_mobiles')}</option>
                  <option value={devicesTypeValues.disks}>{t('scenarios.devicesType_disks')}</option>
                </select>
              </div>
            </div>

            {user.roleId <= roles.stAdmin && (
              <div >
                <div className="sidebar__select" style={{ padding: 0 }}>
                  <p className="sidebar__label">{t('scenarios.shareWith')}</p>
                  <select
                    value={newScenario.sharingOptions}
                    className="singleSelect"
                    title={t('scenarios.shareWith')}
                    onChange={e => {
                      const sharingOptions = Number(e.target.value);
                      if (
                        sharingOptions === sharingValues.noOne ||
                        sharingOptions === sharingValues.everyone ||
                        sharingOptions === sharingValues.allStAdmins
                      ) {

                        setNewScenario({
                          ...newScenario,
                          sharingOptions: sharingOptions,
                          groups: [],
                          locations: []
                        });
                      }
                      else {
                        setNewScenario({ ...newScenario, sharingOptions: sharingOptions })
                      }
                    }}
                  >
                    <option value={sharingValues.noOne}>{t('scenarios.no_one')}</option>
                    <option value={sharingValues.everyone}>{t('scenarios.everyone')}</option>
                    <option value={sharingValues.allStAdmins}>{t('scenarios.allStAdmins')}</option>
                    <option value={sharingValues.allGroupAdmins}>{t('scenarios.allGroupAdmins')}</option>
                    <option value={sharingValues.allGroupUsers}>{t('scenarios.allGroupUsers')}</option>
                  </select>
                </div>

                <div className="checkbox action">
                  <input
                    disabled={newScenario.sharingOptions === sharingValues.noOne || newScenario.sharingOptions === sharingValues.everyone}
                    id="allowModifications"
                    type="checkbox"
                    defaultChecked={newScenario.allowModifications}
                    onChange={e => {
                      setNewScenario({ ...newScenario, allowModifications: !newScenario.allowModifications })
                    }}
                  />
                  <label htmlFor="allowModifications">{t('scenarios.allowModifications')}</label>
                </div>
              </div>
            )}

            {user.roleId === roles.admin && (
              <div >
                <div className="sidebar__select" style={{ padding: 0 }}>
                  <p className="sidebar__label">{t('scenarios.shareWith')}</p>
                  <select
                    value={newScenario.sharingOptions}
                    className="singleSelect"
                    title={t('scenarios.shareWith')}
                    onChange={e => {
                      const sharingOptions = Number(e.target.value);
                      setNewScenario({ ...newScenario, sharingOptions: sharingOptions })
                    }}
                  >
                    <option value={sharingValues.noOne}>{t('scenarios.no_one')}</option>
                    {user.email.includes('DEMO_USER_$') == false && <option value={sharingValues.allGroupAdmins}>{t('scenarios.allGroupAdmins')}</option>}
                    {user.email.includes('DEMO_USER_$') == false && <option value={sharingValues.allGroupUsers}>{t('scenarios.allGroupUsers')}</option>}
                  </select>
                </div>

                <div className="checkbox action">
                  <input
                    disabled={newScenario.sharingOptions === sharingValues.noOne || newScenario.sharingOptions === sharingValues.everyone}
                    id="allowModifications"
                    type="checkbox"
                    defaultChecked={newScenario.allowModifications}
                    onChange={e => {
                      setNewScenario({ ...newScenario, allowModifications: !newScenario.allowModifications })
                    }}
                  />
                  <label htmlFor="allowModifications">{t('scenarios.allowModifications')}</label>
                </div>
              </div>
            )}

            {user.roleId === roles.user && (
              <div >
                <div className="sidebar__select" style={{ padding: 0 }}>
                  <p className="sidebar__label">{t('scenarios.shareWith')}</p>
                  <select
                    value={newScenario.sharingOptions}
                    className="singleSelect"
                    title={t('scenarios.shareWith')}
                    onChange={e => {
                      const sharingOptions = Number(e.target.value);
                      setNewScenario({ ...newScenario, sharingOptions: sharingOptions })
                    }}
                  >
                    <option value={sharingValues.noOne}>{t('scenarios.no_one')}</option>
                    <option value={sharingValues.allGroupUsers}>{t('scenarios.allGroupUsers')}</option>
                  </select>
                </div>

                <div className="checkbox action">
                  <input
                    disabled={newScenario.sharingOptions === sharingValues.noOne || newScenario.sharingOptions === sharingValues.everyone}
                    id="allowModifications"
                    type="checkbox"
                    defaultChecked={newScenario.allowModifications}
                    onChange={e => {
                      setNewScenario({ ...newScenario, allowModifications: !newScenario.allowModifications })
                    }}
                  />
                  <label htmlFor="allowModifications">{t('scenarios.allowModifications')}</label>
                </div>
              </div>
            )}

            {user.roleId <= roles.stAdmin && (
              <div >
                {(newScenario.sharingOptions !== sharingValues.everyone) && (newScenario.sharingOptions !== sharingValues.noOne) && (newScenario.sharingOptions !== sharingValues.allStAdmins) && (
                  <div className="sidebar__select" style={{ padding: 0 }}>
                    <p className="sidebar__label">{t('admin.accounts.columns.group')}</p>
                    <select
                      value={newScenario.groups}
                      className="singleSelect"
                      title={t('scenarios.devicesType')}
                      onChange={handleChangeGroup}
                    >
                      <option value="0" hidden>{multiSelectStrings(t, 'grp', newScenario).selectSomeItems}</option>
                      {pickers.groups.map(group => <option key={group.value} value={group.value}>{group.label}</option>)}
                    </select>
                  </div>
                )}
              </div>
            )}


            <Container
              dragHandleSelector=".drag-handle"
              lockAxis="x|y"
              onDrop={handleDragModule}
            >
              {/* {newScenario.modules.map((module, key) => (
                <Draggable key={key} >
                  <Module
                    nb={key}
                    // open={open}
                    module={module}
                    // setOpen={setOpen}
                    setModule={setModule}
                    handleRemoveModule={handleRemoveModule}
                    newSeq={!module?.id || module?.id !== scenario.modules[key]?.id}
                  />
                </Draggable>
              ))} */}

              {lines.map((line, key) => (
                <Draggable key={key} >
                  <ModuleWithSequence
                    nb={key}
                    line={line}
                    setModule={setModule}
                    handleChangeLine={handleChangeLine}
                    handleRemoveLine={handleRemoveLine}
                    newSeq={!line.module?.id || line.module?.id !== scenario.modules[key]?.id}
                  />
                </Draggable>
              ))}

              <Button
                className="button"
                onClick={handleAddLine}
                style={{ backgroundColor: 'var(--button-bg)', margin: '20px auto 0' }}
                startIcon={<span className="material-icons-round">add_circle_outline</span>}
              >
                {t('scenarios.modules.add')}
              </Button>
            </Container>
          </div>

          {module &&
            <UpdateModule
              module={module}
              setModule={setModule}
              handleUpdateModule={handleUpdateModule}
              handleRemoveModule={handleRemoveModule}
            />}
        </PromptWrapper>

        <PromptActions>
          <Button className="btnSecondary"
            disabled={!loaded}
            onClick={() => setSelectedScenario(null)}
          >
            {t('global.cancel')}
          </Button>

          <Button className="btnPrimary"
            disabled={
              !loaded ||
              errorInLines ||
              isEqual(scenario, newScenario) ||
              (
                (newScenario.sharingOptions === sharingValues.allGroupAdmins || newScenario.sharingOptions === sharingValues.allGroupUsers) &&
                (newScenario.groups && newScenario.groups.length === 0)
              )
            }
            onClick={() => handleUpdateScenario(newScenario)}
          >
            {!loaded ? <BeatLoader color="white" css="transform:translateY(4px)" /> : t('global.update')}
          </Button>

        </PromptActions>
      </form >
    </Prompt >
  );
}
